import { Header } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styles from './styles/Activity.module.scss';

type Props = {
  header: string;
  overview?: boolean;
};

const TitleContainer = ({ header, overview }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={overview ? `${styles.titleContainerOverview}` : `${styles.titleContainer}`}>
      <Header className={styles.h2Title} as="h2">
        {t(`${header}`)}
      </Header>
    </div>
  );
};

export default TitleContainer;
